import React from "react";
import { useTranslation } from "next-i18next";

import { SignInIcon } from "src/assets/CommonIcons";
import { useAuthContext } from "@/contexts/auth";
import Button from "@/shared/components/Button/Button";
import { BUTTON_VARIANT } from "@/shared/components/Button/Button.constants";

import styles from "./PleaseSignInPage.module.scss";

const PleaseSignInPage = () => {
  const { t } = useTranslation();
  const { login } = useAuthContext();
  const onAuthHandler = () => {
    login();
  };

  return (
    <div className={styles["please-sign-in-page"]}>
      <div className={styles["please-sign-in-page-header"]}>
        <SignInIcon className={styles["sign-in-icon"]} />
      </div>
      <div className={styles["please-sign-in-page-content"]}>
        <p className={styles["text"]}>{t("pleaseSignInText")}</p>

        <Button
          className={styles["please-sign-in-page-button"]}
          onClick={onAuthHandler}
        >
          {t("signIn")}
        </Button>
      </div>
    </div>
  );
};

export default PleaseSignInPage;
